import { Instagram, Facebook, Mail, Phone, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

function WA({ number, children, className }) {
  const n = (number || "").replace(/[^0-9]/g, "");
  return (
    <a
      href={`https://wa.me/${n}`}
      target="_blank"
      rel="noreferrer"
      className={className}
    >
      {children}
    </a>
  );
}

export default function Footer({ settings }) {
  const s = settings || {};
  return (
    <footer
      id="contact"
      data-testid="site-footer"
      className="relative overflow-hidden bg-navy pt-24 md:pt-40 pb-10 border-t border-navy/50 text-ivory"
    >
      {/* Big brand wordmark */}
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 grid md:grid-cols-12 gap-14">
        <div className="md:col-span-7">
          <p className="chapter-num mb-6">— Get in touch</p>
          <h2 className="font-display text-5xl sm:text-7xl lg:text-8xl leading-[0.95] tracking-tight text-ivory">
            Let's weave <br />
            <span className="italic text-gold">something premium.</span>
          </h2>

          <div className="mt-10 flex flex-wrap items-center gap-3">
            {s.whatsapp && (
              <WA
                number={s.whatsapp}
                className="px-6 py-3 rounded-full bg-gold text-navy text-xs uppercase tracking-[0.2em] font-semibold hover:bg-ivory transition-colors"
              >
                Chat on WhatsApp
              </WA>
            )}
            {s.email && (
              <a
                href={`mailto:${s.email}`}
                className="px-6 py-3 rounded-full border border-ivory/25 text-ivory text-xs uppercase tracking-[0.2em] hover:border-gold hover:text-gold transition-colors"
                data-testid="footer-email-link"
              >
                Email us
              </a>
            )}
          </div>
        </div>

        <div className="md:col-span-5 grid grid-cols-2 gap-8 text-sm">
          <div>
            <p className="chapter-num mb-4">01 · Reach</p>
            <ul className="space-y-3 text-ivory/75">
              {s.phone && (
                <li className="flex items-start gap-2">
                  <Phone size={14} className="mt-1 text-gold" />
                  <a href={`tel:${s.phone}`} data-testid="footer-phone">
                    {s.phone}
                  </a>
                </li>
              )}
              {s.email && (
                <li className="flex items-start gap-2">
                  <Mail size={14} className="mt-1 text-gold" />
                  <a href={`mailto:${s.email}`}>{s.email}</a>
                </li>
              )}
              {s.address && (
                <li className="flex items-start gap-2">
                  <MapPin size={14} className="mt-1 text-gold" />
                  <span>{s.address}</span>
                </li>
              )}
            </ul>
          </div>
          <div>
            <p className="chapter-num mb-4">02 · Follow</p>
            <ul className="space-y-3 text-ivory/75">
              {s.instagram && (
                <li>
                  <a
                    href={s.instagram}
                    target="_blank"
                    rel="noreferrer"
                    className="flex items-center gap-2 hover:text-gold transition-colors"
                    data-testid="footer-instagram"
                  >
                    <Instagram size={14} /> Instagram
                  </a>
                </li>
              )}
              {s.facebook && (
                <li>
                  <a
                    href={s.facebook}
                    target="_blank"
                    rel="noreferrer"
                    className="flex items-center gap-2 hover:text-gold transition-colors"
                    data-testid="footer-facebook"
                  >
                    <Facebook size={14} /> Facebook
                  </a>
                </li>
              )}
              {s.whatsapp && (
                <li>
                  <WA
                    number={s.whatsapp}
                    className="flex items-center gap-2 hover:text-gold transition-colors"
                  >
                    <span className="w-3.5 h-3.5 rounded-full bg-emerald-400/70" />
                    WhatsApp
                  </WA>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>

      {/* Massive B'Premium wordmark */}
      <div className="mt-20 md:mt-32 px-4 md:px-5 overflow-hidden">
        <p
          aria-hidden
          data-testid="footer-wordmark"
          className="font-display italic text-ivory/[0.09] leading-none text-center whitespace-nowrap text-[15vw] md:text-[22vw] lg:text-[20vw]"
        >
          B'Premium
        </p>
      </div>

      <div className="mx-auto max-w-[1400px] px-5 md:px-10 mt-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-ivory/45">
        <p>© {new Date().getFullYear()} B'Premium. Woven with intent.</p>
        <div className="flex items-center gap-6">
          <Link to="/catalog" className="hover:text-gold">
            Catalog
          </Link>
          <Link to="/admin/login" className="hover:text-gold">
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
}
